export default "__VITE_PUBLIC_ASSET__dc73598c__"